module.exports = __webpack_public_path__ + "img/france-endocrine-nutritional-metabolic-diseases-female.459e1a72.png";